import { BackOfficeMarketsEnums } from "../../../shared/shared.enums";
import { IFullNameValidation } from "../../../shared/shared.interfaces";

export enum StatusEnums {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum TypeEnums {
  STANDARD_DOC = "STANDARD_DOC",
  NON_STANDARD_DOC = "NON_STANDARD_DOC",
}

export enum CaptureBackSideEnums {
  TRUE = "TRUE",
  FALSE = "FALSE",
}

export interface ISingleIdentityRequest {
  en: string;
  fr: string;
  documentStandard?: TypeEnums;
  captureBackSide?: boolean;
  documentId: string;
  documentType?: string;
  status?: StatusEnums;
}

export interface ICreateIdentityRequest {
  identity: Array<ISingleIdentityRequest>;
}

export interface IUpdateIdentityRequest {
  status?: StatusEnums;
  en?: string;
  fr?: string;
  documentId?: string;
  documentType?: string;
  captureBackSide?: boolean;
}

export interface IUpdateIdentityResponse {
  en: string;
  fr: string;
  type?: string;
  documentStandard?: TypeEnums;
  captureBackSide?: CaptureBackSideEnums;
  documentId: string;
  status?: StatusEnums;
  urn?: any;
  documentType?: string;
}

export type FullNameValidationRuleType = {
  [key in keyof typeof BackOfficeMarketsEnums]: IFullNameValidation;
};
